import * as ActionTypes from '../Actions/OnboardingActions';
import * as UserActionTypes from '../Actions/UserActions';

export const onboarding = (
  state = {
    user: {},
    brand: {}
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.UPDATE_ONBOARDING_OBJECT: {
      return {
        ...state,
        ...action.updates
      };
    }

    case ActionTypes.REGISTER_BRAND_SUCCESS: {
      return {
        ...state,
        brand: {
          ...state.brand,
          ...action.brand,
          registrationCode: action.code
        }
      };
    }

    case ActionTypes.REGISTER_BRAND_FAILURE: {
      window.ALERT.error(
        action.error || 'There was an error registering your brand. Please make sure you have entered a valid registration code and try again.'
      );
      return state;
    }

    case ActionTypes.SET_BRAND_DOMAINS_TO_SETUP: {
      return {
        ...state,
        domainsToSetup: action.domains
      };
    }

    case ActionTypes.UPDATE_BRAND_DOMAIN_TO_SETUP: {
      return {
        ...state,
        domainsToSetup: state.domainsToSetup.map(domainToSetup => {
          if (domainToSetup.domain === action.domain) return { ...domainToSetup, ...action.updates };
          return domainToSetup;
        })
      };
    }

    case ActionTypes.BRAND_ONBOARDING_PANEL_VIEWED: {
      return {
        ...state,
        viewedPanels: state.viewedPanels ? [...new Set([...state.viewedPanels, action.panelName])] : [action.panelName]
      };
    }

    case UserActionTypes.LOGOUT_USER_SUCCESS:
    case ActionTypes.CLEAR_ONBOARDING_OBJECTS: {
      return {
        user: {},
        brand: {}
      };
    }

    default:
      return state;
  }
};
